module.exports = __webpack_public_path__ + "static/media/HCMM687.0c877180.jpg";